import { combineReducers } from "redux";
import global from "./global/reducers";
import auth from "./auth/reducers";
import candidate from './candidate/reducers';

export default combineReducers({ global, auth, candidate });
